<template>
    <div class="main-content" :style="mainContentViewHeight" style="padding: 24px">
      <el-form :inline="true" :model="dataForm"  @submit.native.prevent @keyup.enter.native="searchBtn">
<!--        <el-form-item style="margin-bottom: 0px;" label="业务类型：" >-->
<!--          <el-select @change="searchBtn" clearable-->
<!--                     style="width:150px;display: inline-block"-->
<!--                     v-model="dataForm.businessType" value-key="value">-->
<!--            <el-option :key="index"-->
<!--                       :label="item.name"-->
<!--                       :value="item.value"-->
<!--                       v-for="(item,index) in businessTypeNamelist"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-input v-model="dataForm.searchKey" placeholder="请输入表单关键字" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchBtn()">查询</el-button>
          <el-button @click="refresh()">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" ref="multipleTable"
                stripe border
                class="table-content"
                v-loading="dataListLoading">
        <el-table-column label="序号"
                         type="index"
                         :index="indexMethod"
                         width="50"
                         align="center">
        </el-table-column>
<!--        <el-table-column label="业务系统" prop='businessTypeName' header-align="center" align="center" width='100'-->
<!--                         :show-overflow-tooltip='true'>-->
<!--          <template slot-scope="scope" >-->
<!--            <el-tag v-if="scope.row.appName" type="success" size="small" :hit="false" effect="plain"  > {{scope.row.appName}}</el-tag>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="描述"
                         prop='msg'
                         header-align="center"
                         align="left"
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-button type="text" title="查看" @click="router(scope.row)">{{scope.row.msg}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         prop='taskDesc'
                         header-align="center"
                         align="center"
                         width='200'>
        </el-table-column>
        <el-table-column
                prop="createDate"
                width="180"
                align="center"
                label="提交时间">
        </el-table-column>
        <el-table-column  label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" title="查看" @click="router(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination background
                     layout="total, sizes, prev, pager, next"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="total"
                     :current-page="pageIndex"
                     @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle"></el-pagination> -->
                     <pagination
                        class="limit"
                        :page-sizes="[10, 20, 50, 100]"
                        :total="total"
                        :page.sync="pageIndex"
                        :limit.sync="pageSize"
                        @pagination="paginationChange">
                     </pagination>

  </div>
</template>

<script>
  // import tabsUtils from "../../../../src/utils/tabs-utils";
  // import authUtils from "../../../../src/utils/auth-utils";
  import Pagination from '@/components/Pagination.vue';
  export default {
    components:{
        Pagination
    },
    props: ['mainContentViewHeight'],
    data() {
      return {
        dataListLoading: false,
        dataForm: {
          searchKey:'' ,//搜索框的值
          businessType: "",

        },
        businessTypeNamelist: [],
        classNodelist: [],
        moreSearchItem: false,
        checkList1: '',
        pageSize: 10,//每页条数
        pageIndex: 1,//当前页
        total: 0,//总条数
        tableData: [],
        multipleSelection: [],
        user: '', //角色类型
        formData: {}
      }
    },
    computed: {

    },
    filters: {

    },
    created() {
      this.getDic('jz_dgwitness_bustype');
    },
    activated() {
        // this.dataListLoading=true;
        let bidSectionId = this.$route.query.bidSectionId || this.$route.params.bidSectionId || '';
        let tenderProjectId = this.$route.query.tenderProjectId || this.$route.params.tenderProjectId || '';
        if(bidSectionId){
            this.dataForm.bidId = bidSectionId;
            this.dataForm.buyprojectId = tenderProjectId;
        }
      this.getDataList()
    },
    mounted() {

    },
    methods: {
      formatterDic(type,key){
        if(key == 'businessTagName'){
          switch(type){
            case 'GC': return 'danger'; break;
            case 'CG': return 'success'; break;
            case 'GT' : return ''; break;
            case 'CQ' : return 'warning'; break;
            case 'QT' : return 'info'; break;
          }
        }
        if(key == 'flownodeTypeTag'){
          switch(type){
            case 1: return 'success'; break;
            case 2: return 'warning'; break;
            case 3 : return ''; break;
          }
        }
        if(key == 'flownodeTypeName'){
          switch(type){
            case 1: return '内嵌'; break;
            case 2: return '跳转'; break;
            case 3: return '定制化'; break;
          }
        }
        return ''

      },

      getDataList() { // 获取列表数据
        this.$http.post('/userTask/list', {
          'page': this.pageIndex,
          'rows': this.pageSize,
          'searchKey': this.dataForm.searchKey,
          'filter': this.dataForm
        },{baseURL:'/proxyhome'}).then(res => {
          this.tableData = res.data.rows;
          this.total = res.data.total;
          this.$refs.multipleTable.doLayout();
          this.dataListLoading=false;
        })
      },

      indexMethod(index) {
        return (this.pageIndex - 1) * this.pageSize + index + 1
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      searchBtn() { //搜索按钮
        this.pageIndex = 1;
        this.pageSize = 10;
        this.getDataList()
      },
      refresh() {//刷新按钮
        this.pageIndex = 1;
        this.dataForm.searchKey = "";
          this.dataForm.businessType = "";
          this.dataForm.bidId = "";
          this.dataForm.buyprojectId = "";
        this.getDataList()
      },

      router(item){ // 跳转详情

          let appList = $authUtils.getAppList();
          let appId = item.appId;
          let filters = appList.filter((item) => item.id == appId);
          if (filters.length > 0) {
              $tabsUtils.removeTab('dynamic_待办跳转');
              this.$nextTick(() => {
                  //  integrateType  0 = 内部模块  1=代理模块 2=微应用 9=外部系统  99 = 系统配置
                  if(item.integrateType == 0){
                      this.$router.push({
                          path:item.url
                      })
                  }
                  if(item.integrateType == 1){
                      var src =  (item.appId ? "/proxy" + item.appId : "")  + (item.url.indexOf('/') == 0?item.url:( '/' + item.url));
                      $tabsUtils.addPanel('待办跳转', src, '')
                  }
                  if(item.integrateType == 9){
                      window.open(item.url)
                  }
              })

          }else{
              this.$message.error('您无权限跳转对应页面。')
          }


      },


      sizeChangeHandle(val) {
        this.pageSize = val;
        this.pageIndex = 1
        this.getDataList()
      },

      currentChangeHandle(val) {
        this.pageIndex = val
        this.getDataList()
      },
      paginationChange(obj){
         this.pageIndex= obj.page||1
         this.pageSize=obj.limit||5
         this.getDataList();
        },
      getDic(type) { // 获取字典
        let url ='sys/dict/searchDictDataList'
        let params={
          'page': 1,
          'rows': 100,
          'searchKey':'',
          'filter':{
            categoryId:type
          }
        }
        this.$http.post(url,params).then(({data}) => {
          if (data ) {
            this.businessTypeNamelist = data.rows
          } else {
            this.businessTypeNamelist = []
          }
        })
      },

    }


}
</script>

<style lang="less">
.main_center {
  .top {
    .input_title {
      display: flex;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}


</style>